import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {AuthReduxState} from "core/redux/auth/AuthReduxState";
import {
    SetAuthStatus,
    HandleLoginResponseType,
    DoLogoutType,
    DoSwitchAccountType,
    DoChangePasswordType,
    SetAuthStatusPayload,
    OnLoggedOut,
    DoLogOffType,
    DoLogOff,
    DoLogoutConfirmationType,
    DoCreateRelatedLeadType,
    DoLoginToAccountType,
    SetInvestAccountAction,
    SetInvestAccountActionPayload,
    SetRelatedLeadUsername,
    SetRelatedLeadUsernamePayload,
} from "core/redux/auth/AuthReduxActions";
import AuthEngine from "core/engine/AuthEngine";
import Platform from "platform/Platform";
import {ServiceType} from "enum/ServiceType";
import {InvestAccountAction} from "enum/InvestAccountAction";
import {AutoLogin} from "core/engine/AutoLogin";

const initialState = (): AuthReduxState => {
    return {
        InvestAction: InvestAccountAction.None,
        IsInvestAccount: false,
        autoLoginBrand: AutoLogin.brand
    };
};

export default class AuthReducer extends Reducer<AuthReduxState> {

    private static _instance: AuthReducer;

    private constructor() {
        super();
        const authEngine: AuthEngine = Platform.engine(ServiceType.Auth);
        this._middlewareActions.set(HandleLoginResponseType, authEngine.handleLoginResponse);
        this._middlewareActions.set(DoLogoutConfirmationType, authEngine.doConfirmLogout);
        this._middlewareActions.set(DoLogoutType, authEngine.doLogout);
        this._middlewareActions.set(DoLogOffType, authEngine.doLogOff);
        this._middlewareActions.set(DoSwitchAccountType, authEngine.doSwitchAccount);
        this._middlewareActions.set(DoChangePasswordType, authEngine.doChangePassword);
        this._middlewareActions.set(DoCreateRelatedLeadType, authEngine.doCreateRelatedLead);
        this._middlewareActions.set(DoLoginToAccountType, authEngine.doLoginToAccount);
    }

    public static instance(): AuthReducer {
        return this._instance || (this._instance = new this());
    }

    public get name(): string {
        return "auth";
    }

    protected setup(builder: ReducerBuilder<AuthReduxState>): void {
        builder
            .init(initialState())
            .handle(OnLoggedOut, (state: AuthReduxState, action: Action<any>) => {
                return {
                    ...initialState()
                };
            })
            .handle(SetAuthStatus, (state: AuthReduxState, {payload}: Action<SetAuthStatusPayload>) => {
                return Object.assign({}, state, payload.authStatus);
            })
            .handle(DoLogOff, (state: AuthReduxState, {payload}: Action<any>) => {
                return Object.assign({}, state, {
                    loggedOff: true
                });
            })
            .handle(SetInvestAccountAction, (state: AuthReduxState, {payload}: Action<SetInvestAccountActionPayload>) => {
                return Object.assign({}, state, {
                    InvestAction: payload.action
                });
            })
            .handle(SetRelatedLeadUsername, (state: AuthReduxState, {payload}: Action<SetRelatedLeadUsernamePayload>) => {
                return Object.assign({}, state, {
                    RelatedLeadUsername: payload.username
                });
            });
    }
}
